const sourceMap: Record<string, string> = {
  CSPARTINT: 'CSPARTINT - CorSo Partner Management',
  EDY: 'Engineering Digital',
  SBRAS: 'ESG Risk',
  'ESG Risk': 'ESG Risk',
  CIH: 'P&C BPM',
  SRN: 'SwiftRe 2.0',
  'CM-CORFLOW': 'UWB',
  CORFLOW: 'UWB',
  Corflow: 'UWB',
  APY: 'WIRE',
};

export function formatDealSource(value: string): string {
  return sourceMap[value] ?? value;
}

export function getKeysByDealSource(targetValue: string): string {
  const keys = Object.keys(sourceMap).filter(key => sourceMap[key] === targetValue);
  return keys.join(';');
}
